import Noun from '../core/Noun';

class MetaPage extends Noun {
  constructor(args = {}) {
    super(args);
  }

  id() {
    return this.attr('name');
  }

  // merge() handled automatically
}

export default MetaPage;
